<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-1">
              <div class="col-12 section_title">CREAR ORDEN DE PRODUCCIÓN</div>
            </div>
          </template>

          <template v-slot:end>
            <Button
              label="GUARDAR"
              icon="pi pi-save"
              class="p-button-success mr-2"
              @click="save()"
            />
          </template>
        </Toolbar>

        <div class="">
          <div class="">
            <div class="formgrid grid">
              <div class="field col-2">
                <label for="codigo">Código PPP</label>
                <InputText
                  v-model="form.codigo"
                  id="codigo"
                  type="text"
                  class="inputfield w-full"
                />
              </div>
              <div class="field col-2">
                <label for="detail">O/C</label>
                <InputText
                  v-model="form.oc"
                  id="detail"
                  type="text"
                  class="inputfield w-full"
                />
              </div>
              <div class="field col-2">
                <label for="client_code">Cód. Cliente</label>
                <InputText
                  v-model="form.client_code"
                  id="client_code"
                  disabled
                  type="text"
                  class="inputfield w-full"
                />
              </div>
              <div class="field col-6">
                <label for="client" style="display: block">NOMBRE CLIENTE</label>
                <Dropdown
                  id="client"
                  v-model="form.client"
                  :options="clients"
                  class="w-full"
                  filter="true"
                  filterBy="name"
                  filterPlaceholder="Buscar..."
                  optionLabel="name"
                  optionValue="id"
                  required="true"
                  autofocus
                  @change="changeClient"
                  :class="{ 'p-invalid': submitted && !form.client }"
                />
              </div>
              
              </div>
              <hr>
            <div class="formgrid grid">
              <div class="field col">
                <label for="detail">PRODUCTO</label>
                <Dropdown
                  id="product_id"
                  v-model="form.product_id"
                  :options="products"
                  class="w-full"
                  filter="true"
                  filterBy="name"
                  filterPlaceholder="Buscar..."
                  optionLabel="name"
                  optionValue="id"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !form.client }"
                />
              </div>
              <div class="field col">
                  <label for="calidad">Material</label> 
                    <Dropdown
                        id="material_id"
                        v-model="material_id"
                        :options="materiales"
                        class="w-full"
                        optionLabel="name"
                        optionValue="id"
                        required="false"
                        autofocus
                    />
                </div>
              <div class="field col">
                <label for="detail">OBSERVACION</label>
                <InputText
                  v-model="form.obs"
                  id="detail"
                  type="text"
                  class="inputfield w-full"
                />
              </div>              
            </div>
          </div>

          <div class="">
            <div class="formgrid grid">
              <div class="field col">
                <label for="detail">CANT</label>
                <InputText
                  v-model="form.cantidad"
                  id="detail"
                  type="text"
                  class="inputfield w-full"
                />
              </div>
              <div class="field col">
                <label for="detail">MEDIDA</label>
                <InputText
                  v-model="form.medida"
                  id="detail"
                  type="text"
                  class="inputfield w-full"
                />
              </div>
              <div class="field col">
                <label for="detail">CLASE-EFICIENCIA</label>
                <InputText
                  v-model="form.clase"
                  id="detail"
                  type="text"
                  class="inputfield w-full"
                />
              </div>
              
            </div>
          </div>

          <div class="">
            <div class="formgrid grid">
              <div class="field col">
                <label for="detail">ENVÍO</label>
                <Dropdown
                    id="currency"
                    v-model="form.delivery_form"
                    :options="deliveries"
                    class="w-full"
                    optionLabel="label"
                    optionValue="value"
                    required="false"
                    autofocus
                />
              </div>
              <div class="field col">
                <label for="detail">FECHA INGRESO</label>
                <input
                  type="date"
                  v-model="form.datein"
                  disabled
                  class="
                    p-inputtext p-component
                    inputfield
                    w-full
                    inputfield
                    w-full
                  "
                />
              </div>
              <div class="field col">
                <label for="detail">PROBABLE ENTREGA</label>
                <input
                  type="date"
                  v-model="form.dateout"
                  class="
                    p-inputtext p-component
                    inputfield
                    w-full
                    inputfield
                    w-full
                  "
                />
              </div>

              <div class="field col">
                <label for="embalado">EMBALADO</label>
                <Dropdown
                    id="embalado"
                    v-model="form.embalado"
                    :options="opciones"
                    class="w-full"
                    optionLabel="label"
                    optionValue="value"
                    required="false"
                    autofocus
                />
              </div>

              <div class="field col">
                <label for="express">EXPRESO</label>
                <Dropdown
                    id="express"
                    v-model="form.express"
                    :options="opciones"
                    class="w-full"
                    optionLabel="label"
                    optionValue="value"
                    required="false"
                    autofocus
                />
              </div>

              <div class="field col">
                <label for="logo">LOGO</label>
                <Dropdown
                    id="log"
                    v-model="form.logo"
                    :options="opciones"
                    class="w-full"
                    optionLabel="label"
                    optionValue="value"
                    required="false"
                    autofocus
                />
              </div>
            </div>
          </div>

          <div class="">
            <div class="formgrid grid">
              <div class="field col">
                <label for="lugar_entrega">LUGAR ENTREGA</label>
                <InputText
                  v-model="form.client_address"
                  id="client_code"                  
                  type="text"
                  class="inputfield w-full"
                />
              </div>
              
              <div class="field col">
                <br>
                  <Button
                    label="AGREGAR PRODUCTO"
                    icon="pi pi-plus"
                    class="p-button-primary mr-2"
                    @click="addProduct()"
                  />
                
              </div>
              
            </div>
          </div>
        </div>

        <div class="">
          <DataTable
            :value="items"
             dataKey="id" 
            class="p-datatable-sm"
            responsiveLayout="scroll"
          >
            <template #header> <h2>Productos</h2> </template>
            <Column header="" >
              <template #body="slotProps">
                  <Button icon="pi pi-times" class="p-button-rounded p-button-danger" @click="delItem(slotProps.data)"></Button>
              </template>
            </Column>
            <Column field="name" header="Producto"></Column>
           <Column headerClass="" field="cantidad" header="Cantidad" headerStyle="max-width: 20%">
              <template #body="slotProps">
                {{ slotProps.data.cantidad }}
              </template>
            </Column>
            <Column field="medida" header="Medida"></Column>
            <Column field="clase" header="Clase"></Column>
            
          </DataTable>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CrudService from "./../../services/crud.service.js"
import axios from "axios";

export default {
  data() {
    return {
      routeName: null, 
      material_id: null,
      deliveries: [
        { value: 0, label: "Retira" },
        { value: 1, label: "Entrega" }
      ],
      ciudades: [
        { value: 'Lugar 1', label: "Lugar 1" },
        { value: 'Lugar 2', label: "Lugar 2" },
        { value: 'Lugar 3', label: "Lugar 3" },        
      ],
      opciones: [{value: 'SI', label: 'SI'}, {value: 'NO', label: 'NO'}],
      form: {
    		client: null,
    		detail: null,
    		dateout: null,
        product_id: null,
    		total: null,
    		datein: new Date().toISOString().slice(0,10),
    		material: "-",
    		piece: "-",
    		tratamiento: 0,
    		cdolarpeso: 0,
    		currency: 0,
        medida: null,
        codigo: null,
        delivery_form: null,
        embalado: null,
        express: null,
        lugar_entrega: null,
        logo: null,
        clase: null,
        products: [],
	  },     
    items: [],
    materiales: [],
    sectors: [],
    submitted: false,
    validationErrors: null,
	  moneyTypes: [
                {value: 0, label: 'AR$'},
                {value: 1, label: 'U$D'},
                {value: 2, label: 'EUR'}                
				],
      clients: [],
      products: []
    };
  },
	 
  created() {
    // get route name
    this.routeName = this.$route.name;
     

  },
  mounted() {
    CrudService.getCRUD("material").then((data) => (this.materiales = data));
    CrudService.getCRUD('cliente').then((data) => {
      this.clients = data;
      this.clients.forEach((client)=>{
        client.name = client.name + ' - ' + client.code;
      });
    });
    CrudService.getCRUD('productos').then((data) => (this.products = data));
    CrudService.getCRUD('sectores').then((data) => (this.sectors = data));
  },
  methods: {
    delItem(item) {
      this.items = this.items.filter((prod) => item.product_id != prod.product_id);
    },
    addProduct() {
      let product = this.products.filter((prod) => prod.id == this.form.product_id);
      let name = product && product.length ? product[0].name : '';
      this.items.push({
        product_id: this.form.product_id,
        sector_id: this.form.sector_id,
        name: name,
        cantidad: this.form.cantidad,
        medida: this.form.medida,
        clase: this.form.clase,
        material_id: this.material_id,
        delivery_form: this.form.delivery_form,
        embalado: this.form.embalado,
        express: this.form.express,
        lugar_entrega: this.form.client_address,
        logo: this.form.logo,
        detalle: this.form.obs,
        total: this.form.total,
        datein: this.form.datein,
        dateout: this.form.dateout
      });

    },
    changeClient() {
      this.form.client_code = ''
      this.form.client_address = ''
      let client = this.clients.filter((item) => item.id == this.form.client);
      if (client && client.length > 0) {
        this.form.client_code = client[0].code
        this.form.client_address = client[0].address
      } 
    },

    displayErrors(errors) {
      
              for (let key in errors) {

                this.validationErrors.push({ "field": key, "message": errors[key] });

                let error = errors[key];
                this.$toast.add({
                  severity: "error",
                  summary: "Error!",
                  detail: error[0],
                  life: 3000,
                });
              }
    },
    save() {
          this.submitted = true;
          this.form.products = this.items;

          CrudService.createCRUD('produccion', 'produccion', this.form).then(
            (data) => {
              
            this.validationErrors = [];
            if (data.status == 400) { 

              this.displayErrors(data.data);
              
              } else {

                this.$toast.add({
                  severity: "success",
                  summary: "Éxito!",
                  detail: "Creado correctamente.",
                  life: 3000,
                });
                
                this.$router.push("/produccion");
              }
            }
          );
        }
     
    },

}
</script>